import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { AuthShell, Field } from "./Login";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await register(email, password, name); navigate("/"); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Create your account" subtitle="Start with a $10,000 paper-trading balance.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <Field label="Name" value={name} onChange={setName} testid="register-name" />
        <Field label="Email" value={email} onChange={setEmail} type="email" testid="register-email" />
        <Field label="Password" value={password} onChange={setPassword} type="password" testid="register-password" />
        {error && <p className="text-sm text-sell" data-testid="register-error">{error}</p>}
        <button data-testid="register-submit" disabled={loading} className="w-full h-11 rounded-lg bg-primary text-primary-foreground font-bold flex items-center justify-center gap-2 hover:opacity-90 disabled:opacity-60">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Create account
        </button>
        <p className="text-sm text-muted-foreground text-center">
          Already registered? <Link to="/login" className="text-primary font-semibold" data-testid="to-login">Sign in</Link>
        </p>
      </form>
    </AuthShell>
  );
}
